const searchTriggers = document.querySelectorAll('.js-search-trigger');
const searchOverlay = document.getElementById('js-search-overlay');
const searchContent = document.getElementById('js-search-content');
const searchClose = document.getElementById('js-search-close');

searchTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
        searchOverlay.classList.add('search--active');

        setTimeout(() => {
            document.querySelector('#js-search-content .search__input input').focus();
        }, 100)
    });
});

if(searchClose) {
    searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('search--active');
    });
}

if(searchContent) {
   new Vue({
      el: searchContent,
      data: {
          loading: false,
          debouncedInput: '',
          results: []
      },
      methods: {
        search(query) {
            this.loading = true;

            fetch(`/ajax_search?term=${query}&include=products,categories,blog_posts,pages,landing_pages`)
            .then(response => response.json())
            .then(data => {
                this.results = data;
                this.loading = false;
            });
        },
        getThumbnail(thumbnail) {
            return thumbnail.replace('100x100', '320x480')
        },
      },
      watch: {
        debouncedInput: function(newValue, oldValue) {
            this.search(newValue);
        }
      },
      computed: {
        products() {
            return this.results.filter(x => x.type === 'product');
        },
        links() {
            return this.results.filter(x => x.type !== 'product');
        },
        query: {
           get() {
             return this.debouncedInput
           },
           set(val) {
             if (this.timeout) clearTimeout(this.timeout)
             this.timeout = setTimeout(() => {
               this.debouncedInput = val
             }, 300)
           }
         }
       }
    });
}